<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
    <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-8">
            <div class="flmid">
                <div class="flgrow">
                    <div class="input-group">
                        <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
                        [(ngModel)]="pService.searchTerm" autocomplete="off" />
                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary">
                                <em class="fa fa-search"></em>
                            </button>
                          </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd && isAddRole">
            <button type="button" (click)="onAdd()" aria-label="Center Align" type="reset" class="add-button btn btn-primary "
              translate>lblAddRole</button>
        </div>
    </div>
</div>
<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="card mb-3">

                <div class="card-header d-flex">
                    <h4 class="card-title" translate>lblRolesRights</h4>
                    
                  </div>

                <div class="table-responsive">

                
                <table class="tablest1">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 55px">#</th>
                            <th scope="col" sortable="roleName" (sort)="onSort($event)" translate>lblRoleName</th>
                            <th scope="col" class="text-center" translate>lblApplication</th>
                            <th scope="col" class="text-center" sortable="roleName" (sort)="onSort($event)" translate>lblPriority</th>
                            <th scope="col" class="text-center" sortable="roleName" (sort)="onSort($event)" translate>lblStampInOut</th>
                            <th scope="col" class="text-center" sortable="isActive" (sort)="onSort($event)" translate>lblActive</th>
                            <th style="width: 75px" scope="col" class="text-center" translate>lblAction</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="userRoles && userRoles.length > 0; else load_else">
                            <tr *ngFor="let role of userRoles; let i=index">
                                <td>{{role.row}}</td>
                                <td>
                                    <ngb-highlight [result]="role.roleName" [term]="pService.searchTerm">
                                    </ngb-highlight>
                                </td>
                                <td class="text-center">
                                    <ngb-highlight [result]="role.application" [term]="pService.searchTerm">
                                    </ngb-highlight>
                                </td>
                                <td class="text-center">
                                    <ngb-highlight [result]="role.priority">
                                    </ngb-highlight>
                                </td>
                                <td>
                                    <div class="custom-control custom-switch mt-0 text-center">
                                        <input type="checkbox" class="custom-control-input"
                                        [checked]="role.isEnableStampIn" id="role-isActive{{i}}"
                                        [(ngModel)]="role.isEnableStampIn"
                                        (change)="stampInOutConfig(role)">
                                        <label class="custom-control-label" for="role-isActive{{i}}" translate>lblActive</label>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <em class="fas"
                                        [ngClass]="{'fa-check': role.isActive, 'fa-close': !role.isActive}"></em>
                                </td>
                                <td class="nowrap text-center">
                                    <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" (click)="onEdit(role)">
                                        <em class="fas fa-pencil-alt fa-lg"></em>
                        </a>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-template #load_else>
                            <tr>
                                <td colspan="4" class="no-record" translate>lblNoRecordsFound</td>
                            </tr>
                        </ng-template>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <div class="d-flex justify-content-between">
                    <div class="d-flex justify-content-between">
                        <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                            [pageSize]="pService.pageSize" [maxSize]="3">
                        </ngb-pagination>
                        <select class="custom-select mx-2" style="width: auto" name="pageSize"
                            [(ngModel)]="pService.pageSize">
                            <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>
                                {{item.label}}
                            </option>
                        </select>
                    </div>
                    <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
                        <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$  | async}}&nbsp;<span class="font17 fontnormal"
                            translate>lblResults</span>
                    </div>
    
                </div>
            </div>

            </div>
          
        </div>
    </div>

</div>